import React, { memo, useCallback } from 'react';

import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AI_QUESTION_CARD_LABELS } from '../../AiQuestionCard.constants';
import {
  trailEditButtonStyles,
  trailItemStyles,
  trailItemTextStyles,
} from '../../AiQuestionCard.styles';
import { AiQuestionCardTestIds } from '../../AiQuestionCard.testIds';

const AnsweredTrailItem = ({ index, header, summary, disabled, onEdit }) => {
  const onEditClick = useCallback(() => onEdit(index), [index, onEdit]);

  return (
    <Box data-testid={AiQuestionCardTestIds.ANSWERED_TRAIL_ITEM} sx={trailItemStyles}>
      <Typography sx={trailItemTextStyles} variant="regular12">
        {`${header}: ${summary}`}
      </Typography>
      <Button
        aria-label={`${AI_QUESTION_CARD_LABELS.EDIT} ${header}`}
        data-testid={AiQuestionCardTestIds.EDIT_BUTTON}
        disabled={disabled}
        size="small"
        sx={trailEditButtonStyles}
        variant="text"
        onClick={onEditClick}
      >
        {AI_QUESTION_CARD_LABELS.EDIT}
      </Button>
    </Box>
  );
};

AnsweredTrailItem.propTypes = {
  index: PropTypes.number.isRequired,
  header: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default memo(AnsweredTrailItem);
